import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import AuthLayout from './auth/AuthLayout';
import AuthForm from './auth/AuthForm';
import { API_BASE_URL } from '../App';
import { validateEmail } from '../lib/emailValidation';
import './LoginPage.css';

function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [fieldErrors, setFieldErrors] = useState({});
  const [error, setError] = useState('');
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    setError('');
    setStatus(null);

    const emailCheck = validateEmail(email);
    if (!emailCheck.ok) {
      setFieldErrors({ email: emailCheck.error });
      return;
    }
    setFieldErrors({});

    setLoading(true);
    try {
      const res = await fetch(`${API_BASE_URL}/sessions/forgot-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: emailCheck.normalized }),
      });
      const data = await res.json().catch(() => ({}));
      setStatus({
        type: 'ok',
        message:
          data.message ||
          'If an account exists with that email, we sent password reset instructions.',
      });
    } catch (e) {
      setError(e.message || 'Network error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout
      title="Reset your password"
      subtitle="Enter your email and we'll send you a link to choose a new password"
    >
      <AuthForm
        fields={[
          {
            id: 'forgot-email',
            name: 'email',
            label: 'Email',
            type: 'email',
            value: email,
            onChange: setEmail,
            autoComplete: 'email',
            error: fieldErrors.email,
            disabled: loading || !!status,
          },
        ]}
        onSubmit={handleSubmit}
        submitLabel="Send reset link"
        loading={loading}
        error={error}
        status={status}
      />

      <p className="auth-form__links">
        <Link to="/login">Back to sign in</Link>
      </p>
    </AuthLayout>
  );
}

export default ForgotPasswordPage;
